export default __webpack_public_path__ + "static/media/si_logo.f8f18da7.png";